export default {
    ALL: 'all',
    AMEX: 'american-express',
    MASTERCARD: 'mastercard',
    VISA: 'visa',
};
